import React, { useState } from 'react';
import { useAccount } from 'wagmi';
import { FlexboxColumn } from '../../../components/action/Flexbox';
import UploadImage from '../../../components/action/UploadImage';
import ButtonApi from '../../../components/ButtonApi';
import ThemedText from '../../../components/theme/ThemedText';
import ThemeLogo from '../../../components/theme/ThemeLogo';
import { useBackendApi } from '../../../helpers/backendHelper';
import { trackClairtyEvent } from '../../../utils';
import './Userform.scss';

const UserForm = ({ onNext, skip, handleOnboarding }) => {
  const { isConnected } = useAccount();

  const [name, setName] = useState();
  const [pfp, setpfp] = useState();
  const backendHelper = useBackendApi();

  function onUpload(value) {
    setpfp(value);
  }

  async function signMessage() {
    if (!isConnected) return;
    if (!name) return alert.error('Hey what should we call you?');
    if (!pfp) return alert.error('Hey show us how you look');

    const formData = new FormData();
    formData.append('avatarFile', pfp);
    formData.append('name', name);
    try {
      const userData = await backendHelper.user.updateUserMetadata(formData);
      trackClairtyEvent('createnewuser', userData?.data?.address);
      onNext(userData.data);
    } catch (error) {
      alert.error('Hmm! Seems there is a problem');
    }
  }
  return (
    <div className='userform_wrapper'>
      <FlexboxColumn className='userform_wrapper_content'>
        <ThemeLogo className='userform_wrapper_content_logo' icon={'mercle'} />
        <div className='userform_wrapper_content_text'>
          <ThemedText.H2>Let’s setup your profile!</ThemedText.H2>
          <ThemedText.P>Enter details for your identity meta account.</ThemedText.P>
        </div>
        <FlexboxColumn gap='2.5rem'>
          <div className='userform_wrapper_content_upload'>
            <UploadImage onImageUpload={onUpload} />
          </div>
          <FlexboxColumn gap='0.5rem'>
            <ThemedText.H5>Enter name</ThemedText.H5>
            <input className='userform_wrapper_content_input' value={name} onChange={e => setName(e.target.value)} />
          </FlexboxColumn>
        </FlexboxColumn>
        <ButtonApi className='userform_wrapper_content_button' onClick={signMessage}>
          Let's go
        </ButtonApi>
      </FlexboxColumn>
    </div>
  );
};

export default UserForm;
